export default __webpack_public_path__ + "static/media/pexels-pixabay-159211.f9b9a271.jpg";